import React from 'react';
var AnimationBlock = function (_a) {
    var text = _a.text;
    return (React.createElement("div", { className: 'animation-block' },
        React.createElement("div", { className: 'animation-block__animation' },
            "\u00A0",
            text)));
};
export default AnimationBlock;
